<template>
  <div id="app">

    <router-view></router-view>

  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  font-size: 16px;
  color: #333;
}

@media screen and (max-width: 980px) {
  #app {
      margin-top:50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue